// ✅ Prevent multiple initializations
if (window.cartEventsInitialized) {
  console.log('Cart events already initialized');
} else {
  window.cartEventsInitialized = true;
  initializeCartEvents();
}

function initializeCartEvents() {
  // Use .off() before .on() to prevent duplicate event handlers
  
  $(document).off("click", ".order_note>h6").on("click", ".order_note>h6", function () {
    $(".order_note").toggleClass("active");
    $(".order_note .textarea_note").slideToggle("slow");
  });

  $(document).off("click", ".luggage_tag .prod_title").on("click", ".luggage_tag .prod_title", function () {
    $(".luggage_tag .prod_title").toggleClass("active");
    $(".drop_down_cont").slideToggle("slow");
  });

  $(document).off("click", ".cart_embroidery .prod_title").on("click", ".cart_embroidery .prod_title", function () {
    $(".cart_embroidery .prod_title").toggleClass("active");
    $(".cart_embroidery .drop_down_cont2").slideToggle("slow");
    $(".cart_embroidery .embro_drop_down").slideUp("slow");
  });

  $(document).off("click", ".cart_embossing .prod_title").on("click", ".cart_embossing .prod_title", function () {
    $(".cart_embossing .prod_title").toggleClass("active");
    $(".cart_embossing .drop_down_cont2").slideToggle("slow");
    $(".cart_embossing .embro_drop_down").slideUp("slow");
  });

  $(document).off("click", ".cart_embroidery .active_prod").on("click", ".cart_embroidery .active_prod", function () {
    $(".cart_embroidery .embro_drop_down").slideToggle("slow");
    $(".cart_embroidery .crt_sans_content").toggleClass("active");
  });

  $(document).off("click", ".cart_embossing .active_prod").on("click", ".cart_embossing .active_prod", function () {
    $(".cart_embossing .embro_drop_down").slideToggle("slow");
    $(".cart_embossing .crt_sans_content").toggleClass("active");
  });

  $(document).off("click", ".cart_embroidery .swatch_embro_title").on("click", ".cart_embroidery .swatch_embro_title", function () {
    $(".swatch_embro_title").removeClass("selected_prod");
    $(this).addClass("selected_prod");
    $(".cart_embroidery .active_prod").text($(this).text());
    $(".cart_embroidery .active_prod").attr(
      "data-product-handle",
      $(this).attr("data-product-handle")
    );
    $(".cart_embroidery .active_prod").attr(
      "data-product-title",
      $(this).attr("data-product-title")
    );
    $(".embro_drop_down").slideToggle("slow");
    $(".crt_sans_content").toggleClass("active");
    $(`.embro_select_color`).hide();
    $(
      `.embro_select_color[data-product-handle="${$(".cart_embroidery .active_prod").attr(
        "data-product-handle"
      )}"]`
    ).show();
    $(".ebro_swatch_color").text(
      $(
        `.embro_select_color[data-product-handle="${$(".cart_embroidery .active_prod").attr(
          "data-product-handle"
        )}"] input:checked`
      ).val()
    );

    // Dynamic character limit logic
    let limit = parseInt($(this).attr("data-limit-characters")) || 6;
    let $input = $("#custom_ebro_text");
    $input.attr("maxlength", limit);
    $input.attr("placeholder", "Enter text up to " + limit + " characters including full stops.");
    let currentVal = $input.val();
    if (currentVal && currentVal.length > limit) {
      $input.val(currentVal.substring(0, limit));
    }
  });

  $(document).off("click", ".cart_embossing .swatch_embro_title").on("click", ".cart_embossing .swatch_embro_title", function () {
    $(".swatch_embro_title").removeClass("selected_prod");
    $(this).addClass("selected_prod");
    $(".cart_embossing .active_prod").text($(this).text());
    $(".cart_embossing .active_prod").attr(
      "data-product-handle",
      $(this).attr("data-product-handle")
    );
    $(".cart_embossing .active_prod").attr(
      "data-product-title",
      $(this).attr("data-product-title")
    );
    $(".embro_drop_down").slideToggle("slow");
    $(".crt_sans_content").toggleClass("active");
    $(`.embro_select_color`).hide();
    $(
      `.embro_select_color[data-product-handle="${$(".cart_embossing .active_prod").attr(
        "data-product-handle"
      )}"]`
    ).show();
    $(".ebro_swatch_color").text(
      $(
        `.embro_select_color[data-product-handle="${$(".cart_embossing .active_prod").attr(
          "data-product-handle"
        )}"] input:checked`
      ).val()
    );
  });

  $(document).off("click", "#yesEmbosing").on("click", "#yesEmbosing", function () {
    $(".custom_embos_text").slideDown("slow");
  });

  $(document).off("click", "#noEmbosing").on("click", "#noEmbosing", function () {
    $(".custom_embos_text").slideUp("slow");
  });

  $(document).off("click", ".swatch_select_ebro").on("click", ".swatch_select_ebro", function () {
    $(".ebro_swatch_color").text($(this).val());
  });

  $(document).off("click", ".add_comp_prod").on("click", ".add_comp_prod", async function () {
    // Prevent multiple clicks
    if ($(this).prop('disabled')) return;
    $(this).prop('disabled', true);

    let addedData;
    if ($(this).data().productHandle == "bag-tag-brown") {
      let prodId = parseInt($('input[name="tag_product_id"]:checked').val());
      let isAddEmbos = $('input[name="embossing"]:checked').val();
      let custEmbbos = $('[name="custom_embos_inupt"]').val().toUpperCase();

      if (isAddEmbos == "yes" && custEmbbos.length < 1) {
        $(".error_custom_embosss").removeClass("hidden");
        $(this).prop('disabled', false);
        return;
      }
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: {
          quantity: 1,
          id: prodId,
          sections: "cart-drawer",
        },
        success: function (response) {
          if (isAddEmbos == "yes") {
            let embo_id = parseInt(
              $('[name="embossing"]:checked').data().productId
            );
            $.ajax({
              type: "POST",
              url: "/cart/add.js",
              dataType: "json",
              data: {
                quantity: 1,
                id: embo_id,
                properties: {
                  "Custom Embossing Text": `${custEmbbos}`,
                  "Product Name": `${
                    $('[name="tag_product_id"]:checked').data().productTitle
                  }`,
                },
                sections: "cart-drawer",
              },
              success: function (response) {
                const html = new DOMParser().parseFromString(
                  response.sections["cart-drawer"],
                  "text/html"
                );
                document.querySelector("cart-quantity").updateHTML(html);
                document.dispatchEvent(new CustomEvent('theme:cartchanged'));
              },
              error: function (error) {
                console.log("sub product-not added");
              },
              complete: function() {
                $(".add_comp_prod").prop('disabled', false);
              }
            });
          } else {
            const html = new DOMParser().parseFromString(
              response.sections["cart-drawer"],
              "text/html"
            );
            document.querySelector("cart-quantity").updateHTML(html);
            $(".add_comp_prod").prop('disabled', false);
          }
        },
        error: function (error) {
          console.log("main product not added");
          $(".add_comp_prod").prop('disabled', false);
        },
      });
    }

    if ($(this).data().productHandle == "embroidery") {
      let prodId = parseInt($(this).data().productId);
      let activeHandle = $(".active_prod").data().productHandle;
      let customText = $('.cart_embroidery input[name="custom_embroidery_text"]').val().toUpperCase();
      let limit = parseInt($('.cart_embroidery input[name="custom_embroidery_text"]').attr("maxlength")) || 6;
      if (customText.length > limit) {
        customText = customText.substring(0, limit);
      }
      if (customText.length < 1) {
        $(".cart_embroidery .error_custom_embro").removeClass("hidden");
        $(this).prop('disabled', false);
        return;
      }
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: {
          quantity: 1,
          id: prodId,
          properties: {
            "Custom Embroidery Text": `${customText}`,
            "Custom Embroidery Text Color": `${$(
              `.embro_select_color[data-product-handle="${activeHandle}"] input:checked`
            ).val()}`,
            "Product Name": `${$(".active_prod").data().productTitle}`,
          },
          sections: "cart-drawer",
        },
        success: function (response) {
          const html = new DOMParser().parseFromString(
            response.sections["cart-drawer"],
            "text/html"
          );
          document.querySelector("cart-quantity").updateHTML(html);
          document.dispatchEvent(new CustomEvent('theme:cartchanged'));
        },
        error: function (error) {
          console.log("embrp not added");
        },
        complete: function() {
          $(".add_comp_prod").prop('disabled', false);
        }
      });
    }

    if ($(this).data().productHandle.includes("embossing")) {
      let prodId = parseInt($(this).data().productId);
      let activeHandle = $(".active_prod").data().productHandle;
      let customText = $('.cart_embossing input[name="custom_embossing_text"]').val().toUpperCase();
      if (customText.length < 1) {
        $(".cart_embossing .error_custom_embro").removeClass("hidden");
        $(this).prop('disabled', false);
        return;
      }
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: {
          quantity: 1,
          id: prodId,
          properties: {
            "Custom Embossing Text": `${customText}`,
            "Product Name": `${$(".active_prod").data().productTitle}`,
          },
          sections: "cart-drawer",
        },
        success: function (response) {
          const html = new DOMParser().parseFromString(
            response.sections["cart-drawer"],
            "text/html"
          );
          document.querySelector("cart-quantity").updateHTML(html);
          document.dispatchEvent(new CustomEvent('theme:cartchanged'));
        },
        error: function (error) {
          console.log("embrp not added");
        },
        complete: function() {
          $(".add_comp_prod").prop('disabled', false);
        }
      });
    }
  });

  $(document).off("click", ".atc_upsell").on("click", ".atc_upsell", function () {
    // Prevent multiple clicks
    if ($(this).prop('disabled')) return;
    $(this).prop('disabled', true);

    let prodId = $(this).data("productId");
    let $btn = $(this);

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: {
        quantity: 1,
        id: prodId,
        sections: "cart-drawer",
      },
      success: function (response) {
        const html = new DOMParser().parseFromString(
          response.sections["cart-drawer"],
          "text/html"
        );
        document.querySelector("cart-quantity").updateHTML(html);
        document.dispatchEvent(new CustomEvent('theme:cartchanged'));
      },
      error: function (error) {
        console.log("Product not added");
      },
      complete: function() {
        $btn.prop('disabled', false);
      }
    });
  });

  function debounce(fn, delay = 300) {
    let timerId;
    return function (...args) {
      clearTimeout(timerId);
      timerId = setTimeout(() => {
        fn.apply(this, args);
      }, delay);
    };
  }

  function updateCartNote(noteText) {
    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      dataType: "json",
      data: { note: noteText },
      success: function (cart) {
        document.dispatchEvent(new CustomEvent('theme:cartchanged'));
      },
      error: function (error) {
        console.error("Failed to update cart note:", error);
      },
    });
  }

  const debouncedNoteUpdate = debounce(updateCartNote, 300);
  $(document).off("input", "#cart-note").on("input", "#cart-note", function () {
    const noteText = $(this).val();
    debouncedNoteUpdate(noteText);
  });

  async function updateCart() {
    let disc_code = $('input[name="discount"]').val();
    let prev_codes = null;
    if (disc_code.length < 1) {
      $(".discount_error").removeClass("hidden");
      $(".enter_code_notvalid").addClass("hidden");
      return;
    }
    await fetch('/cart.json').then(response => response.json()).then(data => {if(data.discount_codes.length){prev_codes = data.discount_codes}});
    let app_code = [];
    if(prev_codes && prev_codes.length){
      for(code of prev_codes){
        if(code.applicable){
          app_code.push(code.code)
        }
      };
    }
    app_code.push(disc_code);
    app_code = app_code.join();
    console.log(app_code)
    await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        discount: app_code,
        sections: "cart-drawer",
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        const html = new DOMParser().parseFromString(
          data.sections["cart-drawer"],
          "text/html"
        );
        document.querySelector("cart-quantity").updateHTML(html);
        if (!data.discount_codes[data.discount_codes.length - 1].applicable) {
          $(".enter_code_notvalid").removeClass("hidden");
        }
      });
  }

  $(document).off("click", ".discount .button.cart_d_btn").on("click", ".discount .button.cart_d_btn", async function () {
    await updateCart();
  });

  $(document).off("input", "#customEmbosInupt").on("input", "#customEmbosInupt", function () {
    let value = $(this).val();
    value = value.replace(/[^a-zA-Z.]/g, "");
    let result = "";
    let letterCount = 0;
    let dotCount = 0;
    for (let i = 0; i < value.length; i++) {
      const char = value[i];
      if (/[a-zA-Z]/.test(char)) {
        if (letterCount < 9) {
          result += char;
          letterCount++;
        }
      } else if (char === ".") {
        if (dotCount < 2) {
          result += char;
          dotCount++;
        }
      }
      if (result.length >= 9) break;
    }
    result = result.toUpperCase();
    $(this).val(result);
  });

  $(document).off("input", "#custom_ebro_text").on("input", "#custom_ebro_text", function () {
    let limit = parseInt($(this).attr("maxlength")) || 6;
    let value = $(this).val();
    value = value.replace(/[^a-zA-Z.]/g, "");
    $(this).val(value);
    if (value.length >= limit) return;
  });

  let activeFetch = null;
  function createAbortController() {
    if (activeFetch) {
      activeFetch.abort();
    }
    const abortController = new AbortController();
    activeFetch = abortController;
    return abortController;
  }

  let timerGifrt = null;
  $(document).off("click", '[name="attributes[Gift Wrapping]"]').on("click", '[name="attributes[Gift Wrapping]"]', function () {
    function debounce() {
      if (timerGifrt) {
        clearTimeout(timerGifrt);
      }
      timerGifrt = setTimeout(() => addGiftProduct(), 300);
    }
    debounce();
  });

  async function addGiftProduct() {
    const abortController = createAbortController();
    const isGiftAdd = $('[name="attributes[Gift Wrapping]"]')[0].checked;
    const hasAlready = $('.gift_checkmark').data().hasGiftAdded;
    if (isGiftAdd && !hasAlready) {
      $('.gift_checkmark').attr('disabled','');
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        signal: abortController.signal,
        data: {
          quantity: 1,
          id: 40105492774947,
          sections: "cart-drawer",
        },
        success: function (response) {
          const html = new DOMParser().parseFromString(
            response.sections["cart-drawer"],
            "text/html"
          );
          document.querySelector("cart-quantity").updateHTML(html);
          document.dispatchEvent(new CustomEvent('theme:cartchanged'));
        },
        error: function (error) {
          console.log("Gift not added");
        },
        complete: function() {
          $('.gift_checkmark').removeAttr('disabled');
        }
      });
    }
    else{
      $('.gift_checkmark').attr('disabled','');
      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        signal: abortController.signal,
        data: {
          quantity: 0,
          id: 40105492774947,
          sections: "cart-drawer",
        },
        success: function (response) {
          const html = new DOMParser().parseFromString(
            response.sections["cart-drawer"],
            "text/html"
          );
          document.querySelector("cart-quantity").updateHTML(html);
          document.dispatchEvent(new CustomEvent('theme:cartchanged'));
        },
        error: function (error) {
          console.log("Gift not added");
        },
        complete: function() {
          $('.gift_checkmark').removeAttr('disabled');
        }
      });
    }
  }

  $(document).off("click", '.siil_op li').on("click", '.siil_op li', function () {
    const giftAddId = $('[name="gift_oolor"]:checked').data().productVariantId;
    const colorVal = $('[name="gift_oolor"]:checked').val();
    $('.sow__selected_val').text(colorVal);
    $('.sel__img img').addClass('hidden');
    $(`[data-color="${colorVal}"]`).removeClass('hidden');
    $('.add_on_thres_limit').attr('data-add-id', giftAddId);
    console.log($('[name="gift_oolor"]:checked').data().productVariantId)
  });

  $(document).off("click", '.add_on_thres_limit').on("click", '.add_on_thres_limit', function () {
    // Prevent multiple clicks
    if ($(this).prop('disabled')) return;
    $(this).prop('disabled', true);

    const prodId = $('.add_on_thres_limit').data().addId;
    let $btn = $(this);

    const customText = $("#custom_laggege_text").val().trim();

    $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: {
          quantity: 1,
          id: prodId,
          properties: {
            "Luggage Text": customText 
          },
          sections: "cart-drawer",
        },
        success: function (response) {
          const html = new DOMParser().parseFromString(
            response.sections["cart-drawer"],
            "text/html"
          );
          cartDrawerUpdate();
          document.querySelector("cart-quantity").updateHTML(html);
          document.dispatchEvent(new CustomEvent('theme:cartchanged'));
        },
        error: function (error) {
          console.log("gift not added");
        },
        complete: function() {
          $btn.prop('disabled', false);
        }
      });
  });

  $(document).off("click", ".remove_discount_btn").on("click", ".remove_discount_btn", async function(e) {
    e.preventDefault();
    const discountCode = $(this).data("discount-code");
    
    try {
      const cartResponse = await fetch('/cart.json');
      const cartData = await cartResponse.json();
      
      let currentCodes = [];
      if (cartData.discount_codes && cartData.discount_codes.length) {
        currentCodes = cartData.discount_codes
          .filter(code => code.code !== discountCode && code.applicable)
          .map(code => code.code);
      }
      
      const updateResponse = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          discount: currentCodes.join(','),
          sections: "cart-drawer",
        }),
      });
      
      const data = await updateResponse.json();
      
      const html = new DOMParser().parseFromString(
        data.sections["cart-drawer"],
        "text/html"
      );
      document.querySelector("cart-quantity").updateHTML(html);
      document.dispatchEvent(new CustomEvent('theme:cartchanged'));
      
      console.log(`Discount code "${discountCode}" removed successfully`);
    } catch (error) {
      console.error("Error removing discount code:", error);
    }
  });
}

function cartDrawerUpdate() {
  var url = window.location.href;
  fetch(url)
   .then(response => response.text())
   .then(html => {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    if (doc.querySelector('.cart_drawer__inner') != null) {
     var mainSectionContent = doc.querySelector('.cart_drawer__inner').innerHTML;
     document.querySelector('.cart_drawer__inner').innerHTML = mainSectionContent;
    }
   })
   .catch(error => {
    console.error('Error fetching collection main section:', error);
   });
}

// remove select button when cap product add in the cart
async function checkAndHideFreeGiftCollection() {
  const freeGiftContainer = document.querySelector('.free_gift_selection_container');
  
  if (!freeGiftContainer) return;
  
  const freeGiftLink = document.querySelector('.free_gift_btn_link');
  if (!freeGiftLink) return;
  
  const collectionUrl = freeGiftLink.getAttribute('href');
  const collectionHandle = collectionUrl.split('/collections/')[1]?.split('?')[0]?.split('/')[0];
  
  if (!collectionHandle) return;
  
  try {
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    
    const collectionResponse = await fetch(`/collections/${collectionHandle}/products.json`);
    const collectionData = await collectionResponse.json();
    
    const collectionProductIds = collectionData.products.map(p => p.id);
    
    const hasCollectionProduct = cart.items.some(item => 
      collectionProductIds.includes(item.product_id)
    );
    
    if (hasCollectionProduct) {
      freeGiftContainer.classList.add('added_cap_product');
      freeGiftContainer.style.display = 'none';
    } else {
      freeGiftContainer.classList.remove('added_cap_product');
      freeGiftContainer.style.display = '';
    }
    
  } catch (error) {
    console.error('Error checking free gift collection:', error);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', checkAndHideFreeGiftCollection);
} else {
  checkAndHideFreeGiftCollection();
}

const cartDrawer = document.querySelector('.cart-drawer');
if (cartDrawer) {
  const observer = new MutationObserver(() => {
    if (cartDrawer.classList.contains('active') || 
        cartDrawer.classList.contains('open') ||
        cartDrawer.style.display !== 'none') {
      checkAndHideFreeGiftCollection();
    }
  });
  
  observer.observe(cartDrawer, { 
    attributes: true, 
    attributeFilter: ['class', 'style'] 
  });
}

document.addEventListener('cart:updated', checkAndHideFreeGiftCollection);
document.addEventListener('cart:refresh', checkAndHideFreeGiftCollection);

const originalFetch = window.fetch;
window.fetch = function(...args) {
  return originalFetch.apply(this, args).then(response => {
    if (args[0] && (args[0].includes('/cart/') || args[0].includes('cart.js'))) {
      setTimeout(checkAndHideFreeGiftCollection, 300);
    }
    return response;
  });
};

setInterval(() => {
  const drawer = document.querySelector('.cart-drawer');
  if (drawer && (drawer.classList.contains('active') || drawer.classList.contains('open'))) {
    checkAndHideFreeGiftCollection();
  }
}, 200);

// ── Embroidery Delay Note Injector ──────────────────────────────────────────
// Zepto app adds "Personalise your Wolf" via its own XHR/fetch.
// After every cart/add, we check if that line item is missing the note
// and inject it via /cart/change.js so it shows in cart & checkout.
const EMBROIDERY_NOTE_KEY   = 'Please note';

async function injectEmbroideryNote() {
  if (!window.cartConfig || !window.cartConfig.enableNote) return;
  try {
    const metafieldsJson = document.getElementById('cart-metafields-json');
    if (!metafieldsJson) return;
    const metafields = JSON.parse(metafieldsJson.innerHTML);
    
    const cart = await fetch('/cart.js').then(r => r.json());
    for (const item of cart.items) {
      const metafieldValue = metafields[item.key];
      
      if (metafieldValue && metafieldValue.trim() !== "") {
        const alreadyHasNote =
          item.properties &&
          item.properties[EMBROIDERY_NOTE_KEY] === metafieldValue;

        if (!alreadyHasNote) {
          // Merge existing properties + our note
          const updatedProps = Object.assign({}, item.properties || {}, {
            [EMBROIDERY_NOTE_KEY]: metafieldValue
          });

          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: item.key,
              properties: updatedProps
            })
          });
          console.log('[HW] Metafield note injected for:', item.product_title);
        }
      }
    }
  } catch (e) {
    console.error('[HW] injectEmbroideryNote error:', e);
  }
}

// Hook into XHR (Zepto app often uses XHR, not fetch)
(function() {
  const XHR = XMLHttpRequest.prototype;
  const origOpen = XHR.open;
  const origSend = XHR.send;

  XHR.open = function(method, url, ...rest) {
    this._hwUrl = url;
    return origOpen.apply(this, [method, url, ...rest]);
  };

  XHR.send = function(...args) {
    if (this._hwUrl && this._hwUrl.includes('/cart/add')) {
      this.addEventListener('load', function() {
        setTimeout(injectEmbroideryNote, 400);
      });
    }
    return origSend.apply(this, args);
  };
})();

// Hook into fetch (in case Zepto uses fetch)
(function() {
  const _origFetch = window._hwOrigFetch || window.fetch;
  window._hwOrigFetch = _origFetch;
  window.fetch = function(...args) {
    const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    const result = _origFetch.apply(this, args);
    if (url.includes('/cart/add')) {
      result.then(() => setTimeout(injectEmbroideryNote, 400)).catch(() => {});
    }
    return result;
  };
})();

// ────────────────────────────────────────────────────────────────────────────
// Old Code

// $(document).ready(function () {
//   $(".order_note>h6").click(function () {
//     $(".order_note").toggleClass("active");
//     $(".order_note .textarea_note").slideToggle("slow");
//   });
//   $(".luggage_tag .prod_title").click(function () {
//     $(".luggage_tag .prod_title").toggleClass("active");
//     $(".drop_down_cont").slideToggle("slow");
//   });
//   // $(".prod_title .overaroundforscroll").click(function () {
//   //   $(".luggage_tag .prod_title").toggleClass("active");
//   //   $(".drop_down_cont").slideToggle("slow");
//   // });
//   $(".cart_embroidery .prod_title").click(function () {
//     $(".cart_embroidery .prod_title").toggleClass("active");
//     $(".cart_embroidery .drop_down_cont2").slideToggle("slow");
//     $(".cart_embroidery .embro_drop_down").slideUp("slow");
//     // setTimeout(()=>document.querySelector(".overaroundforscroll_second").dispatchEvent(new MouseEvent('click', {bubbles: false})),300);
//   });
//     $(".cart_embossing .prod_title").click(function () {
//     $(".cart_embossing .prod_title").toggleClass("active");
//     $(".cart_embossing .drop_down_cont2").slideToggle("slow");
//     $(".cart_embossing .embro_drop_down").slideUp("slow");
//     // setTimeout(()=>document.querySelector(".overaroundforscroll_second").dispatchEvent(new MouseEvent('click', {bubbles: false})),300);
//   });
//   $(".cart_embroidery .active_prod").click(function () {
//     $(".cart_embroidery .embro_drop_down").slideToggle("slow");
//     $(".cart_embroidery .crt_sans_content").toggleClass("active");
//   });
//   $(".cart_embossing .active_prod").click(function () {
//     $(".cart_embossing .embro_drop_down").slideToggle("slow");
//     $(".cart_embossing .crt_sans_content").toggleClass("active");
//   });

//   $(".cart_embroidery .swatch_embro_title").click(function () {
//     $(".swatch_embro_title").removeClass("selected_prod");
//     $(this).addClass("selected_prod");
//     $(".cart_embroidery .active_prod").text($(this).text());
//     $(".cart_embroidery .active_prod").attr(
//       "data-product-handle",
//       $(this).attr("data-product-handle")
//     );
//     $(".cart_embroidery .active_prod").attr(
//       "data-product-title",
//       $(this).attr("data-product-title")
//     );
//     $(".embro_drop_down").slideToggle("slow");
//     $(".crt_sans_content").toggleClass("active");
//     $(`.embro_select_color`).hide();
//     $(
//       `.embro_select_color[data-product-handle="${$(".cart_embroidery .active_prod").attr(
//         "data-product-handle"
//       )}"]`
//     ).show();
//     $(".ebro_swatch_color").text(
//       $(
//         `.embro_select_color[data-product-handle="${$(".cart_embroidery .active_prod").attr(
//           "data-product-handle"
//         )}"] input:checked`
//       ).val()
//     );
//   });
//   $(".cart_embossing .swatch_embro_title").click(function () {
//     $(".swatch_embro_title").removeClass("selected_prod");
//     $(this).addClass("selected_prod");
//     $(".cart_embossing .active_prod").text($(this).text());
//     $(".cart_embossing .active_prod").attr(
//       "data-product-handle",
//       $(this).attr("data-product-handle")
//     );
//     $(".cart_embossing .active_prod").attr(
//       "data-product-title",
//       $(this).attr("data-product-title")
//     );
//     $(".embro_drop_down").slideToggle("slow");
//     $(".crt_sans_content").toggleClass("active");
//     $(`.embro_select_color`).hide();
//     $(
//       `.embro_select_color[data-product-handle="${$(".cart_embossing .active_prod").attr(
//         "data-product-handle"
//       )}"]`
//     ).show();
//     $(".ebro_swatch_color").text(
//       $(
//         `.embro_select_color[data-product-handle="${$(".cart_embossing .active_prod").attr(
//           "data-product-handle"
//         )}"] input:checked`
//       ).val()
//     );
//   });

//   $("#yesEmbosing").click(function () {
//     $(".custom_embos_text").slideDown("slow");
//   });
//   $("#noEmbosing").click(function () {
//     $(".custom_embos_text").slideUp("slow");
//   });
//   $(".swatch_select_ebro").click(function () {
//     $(".ebro_swatch_color").text($(this).val());
//   });
// $(".add_comp_prod").click(async function () {
//     // console.log($(this).data().productHandle);
//     let addedData;
//     if ($(this).data().productHandle == "bag-tag-brown") {
//       let prodId = parseInt($('input[name="tag_product_id"]:checked').val());
//       let isAddEmbos = $('input[name="embossing"]:checked').val();
//       // let custEmbbos = $('[name="custom_embos_inupt"]').val();
//       let custEmbbos = $('[name="custom_embos_inupt"]').val().toUpperCase();

      
//       if (isAddEmbos == "yes" && custEmbbos.length < 1) {
//         $(".error_custom_embosss").removeClass("hidden");
//         return;
//       }
//       $.ajax({
//         type: "POST",
//         url: "/cart/add.js",
//         dataType: "json",
//         data: {
//           quantity: 1,
//           id: prodId,
//           sections: "cart-drawer",
//         },
//         success: function (response) {
//           if (isAddEmbos == "yes") {
//             let embo_id = parseInt(
//               $('[name="embossing"]:checked').data().productId
//             );
//             $.ajax({
//               type: "POST",
//               url: "/cart/add.js",
//               dataType: "json",
//               data: {
//                 quantity: 1,
//                 id: embo_id,
//                 properties: {
//                   "Custom Embossing Text": `${custEmbbos}`,
//                   "Product Name": `${
//                     $('[name="tag_product_id"]:checked').data().productTitle
//                   }`,
//                 },
//                 sections: "cart-drawer",
//               },
//               success: function (response) {
//                 const html = new DOMParser().parseFromString(
//                   response.sections["cart-drawer"],
//                   "text/html"
//                 );
//                 document.querySelector("cart-quantity").updateHTML(html);
//                 document.dispatchEvent(new CustomEvent('theme:cartchanged'));
//               },
//               error: function (error) {
//                 console.log("sub product-not added");
//               },
//             });
//           } else {
//             // console.log(response);
//             const html = new DOMParser().parseFromString(
//               response.sections["cart-drawer"],
//               "text/html"
//             );
//             document.querySelector("cart-quantity").updateHTML(html);
//           }
//         },
//         error: function (error) {
//           console.log("main product not added");
//         },
//       });
//     }

//     if ($(this).data().productHandle == "embroidery") {
//       let prodId = parseInt($(this).data().productId);
//       let activeHandle = $(".active_prod").data().productHandle;
//       let customText = $('.cart_embroidery input[name="custom_embroidery_text"]').val().toUpperCase();
//       if (customText.length < 1) {
//         $(".cart_embroidery .error_custom_embro").removeClass("hidden");
//         return;
//       }
//       $.ajax({
//         type: "POST",
//         url: "/cart/add.js",
//         dataType: "json",
//         data: {
//           quantity: 1,
//           id: prodId,
//           properties: {
//             "Custom Embroidery Text": `${customText}`,
//             "Custom Embroidery Text Color": `${$(
//               `.embro_select_color[data-product-handle="${activeHandle}"] input:checked`
//             ).val()}`,
//             "Product Name": `${$(".active_prod").data().productTitle}`,
//           },
//           sections: "cart-drawer",
//         },
//         success: function (response) {
//           // console.log("embrp", response);
//           const html = new DOMParser().parseFromString(
//             response.sections["cart-drawer"],
//             "text/html"
//           );
//           document.querySelector("cart-quantity").updateHTML(html);
//           document.dispatchEvent(new CustomEvent('theme:cartchanged'));
//         },
//         error: function (error) {
//           console.log("embrp not added");
//         },
//       });
//     }
//     if ($(this).data().productHandle.includes("embossing")) {
//       let prodId = parseInt($(this).data().productId);
//       let activeHandle = $(".active_prod").data().productHandle;
//       let customText = $('.cart_embossing input[name="custom_embossing_text"]').val().toUpperCase();
//       if (customText.length < 1) {
//         $(".cart_embossing .error_custom_embro").removeClass("hidden");
//         return;
//       }
//       $.ajax({
//         type: "POST",
//         url: "/cart/add.js",
//         dataType: "json",
//         data: {
//           quantity: 1,
//           id: prodId,
//           properties: {
//             "Custom Embossing Text": `${customText}`,
//             "Product Name": `${$(".active_prod").data().productTitle}`,
//           },
//           sections: "cart-drawer",
//         },
//         success: function (response) {
//           // console.log("embrp", response);
//           const html = new DOMParser().parseFromString(
//             response.sections["cart-drawer"],
//             "text/html"
//           );
//           document.querySelector("cart-quantity").updateHTML(html);
//           document.dispatchEvent(new CustomEvent('theme:cartchanged'));
//         },
//         error: function (error) {
//           console.log("embrp not added");
//         },
//       });
//     }
//   });

//   $(document).on("click", ".atc_upsell", function () {
//   let prodId = $(this).data("productId");

//   $.ajax({
//     type: "POST",
//     url: "/cart/add.js",
//     dataType: "json",
//     data: {
//       quantity: 1,
//       id: prodId,
//       sections: "cart-drawer",
//     },
//     success: function (response) {
//       // ✅ Update cart drawer content
//       const html = new DOMParser().parseFromString(
//         response.sections["cart-drawer"],
//         "text/html"
//       );
//       document.querySelector("cart-quantity").updateHTML(html);
//       document.dispatchEvent(new CustomEvent('theme:cartchanged'));
//     },
//     error: function (error) {
//       console.log("Product not added");
//     },
//   });
// });

//   function debounce(fn, delay = 300) {
//     let timerId;
//     return function (...args) {
//       clearTimeout(timerId);
//       timerId = setTimeout(() => {
//         fn.apply(this, args);
//       }, delay);
//     };
//   }

//   function updateCartNote(noteText) {
//     $.ajax({
//       type: "POST",
//       url: "/cart/update.js",
//       dataType: "json",
//       data: { note: noteText },
//       success: function (cart) {
//         document.dispatchEvent(new CustomEvent('theme:cartchanged'));
//         // console.log("Cart note updated:", cart.note);
//       },
//       error: function (error) {
//         console.error("Failed to update cart note:", error);
//       },
//     });
//   }

//   const debouncedNoteUpdate = debounce(updateCartNote, 300);
//   $("#cart-note").on("input", function () {
//     const noteText = $(this).val();
//     debouncedNoteUpdate(noteText); // Only fires if user stops typing for 300ms
//   });

//   async function updateCart() {
//     let disc_code = $('input[name="discount"]').val();
//     let prev_codes = null;
//     if (disc_code.length < 1) {
//       $(".discount_error").removeClass("hidden");
//       $(".enter_code_notvalid").addClass("hidden");
//       return;
//     }
//     await fetch('/cart.json').then(response => response.json()).then(data => {if(data.discount_codes.length){prev_codes = data.discount_codes}});
//     let app_code = [];
//     if(prev_codes && prev_codes.length){
//       for(code of prev_codes){
//         if(code.applicable){
//           app_code.push(code.code)
//         }
//       };
//     }
//     app_code.push(disc_code);
//     app_code = app_code.join();
//     console.log(app_code)
//     await fetch("/cart/update.js", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({
//         discount: app_code,
//         sections: "cart-drawer",
//       }),
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         // console.log(data.discount_codes[0].applicable);
//         const html = new DOMParser().parseFromString(
//           data.sections["cart-drawer"],
//           "text/html"
//         );
//         document.querySelector("cart-quantity").updateHTML(html);
//         // $(this).text("APPLIED");
//         // $(this).attr("disabled", "");
//         if (!data.discount_codes[data.discount_codes.length - 1].applicable) {
//           $(".enter_code_notvalid").removeClass("hidden");
//         }
//       });
//   }
//   $(".discount .button.cart_d_btn").click(async function () {
//     await updateCart();
//   });
//   $("#customEmbosInupt").on("input", function () {
//     let value = $(this).val();
//     value = value.replace(/[^a-zA-Z.]/g, "");
//     let result = "";
//     let letterCount = 0;
//     let dotCount = 0;
//     for (let i = 0; i < value.length; i++) {
//       const char = value[i];
//       if (/[a-zA-Z]/.test(char)) {
//         if (letterCount < 9) {
//           result += char;
//           letterCount++;
//         }
//       } else if (char === ".") {
//         if (dotCount < 2) {
//           result += char;
//           dotCount++;
//         }
//       }
//       if (result.length >= 9) break;
//     }
//     result = result.toUpperCase();
//     $(this).val(result);
//   });
//   $("#custom_ebro_text").on("input", function () {
//     let value = $(this).val();
//     value = value.replace(/[^a-zA-Z.]/g, "");
//     $(this).val(value);
//     if (value.length >= 6) return;
//   });
//    let activeFetch = null;
//   function createAbortController() {
//     if (activeFetch) {
//       activeFetch.abort();
//     }

//     const abortController = new AbortController();
//     activeFetch = abortController;
//     return abortController;
//   }
//   let timerGifrt = null;
//   $('[name="attributes[Gift Wrapping]"]').click(function () {
//     function debounce() {
//       if (timerGifrt) {
//         clearTimeout(timerGifrt);
//       }
//       timerGifrt = setTimeout(() => addGiftProduct(), 300);
//     }
//     debounce();
//   });
//   async function addGiftProduct() {
//     const abortController = createAbortController();
//     const isGiftAdd = $('[name="attributes[Gift Wrapping]"]')[0].checked;
//     const hasAlready = $('.gift_checkmark').data().hasGiftAdded;
//     if (isGiftAdd && !hasAlready) {
//       $('.gift_checkmark').attr('disabled','');
//       $.ajax({
//         type: "POST",
//         url: "/cart/add.js",
//         dataType: "json",
//         signal: abortController.signal,
//         data: {
//           quantity: 1,
//           id: 40105492774947,
//           sections: "cart-drawer",
//         },
//         success: function (response) {
//           // console.log("Gift", response);
//           const html = new DOMParser().parseFromString(
//             response.sections["cart-drawer"],
//             "text/html"
//           );
//           document.querySelector("cart-quantity").updateHTML(html);
//           document.dispatchEvent(new CustomEvent('theme:cartchanged'));
//         },
//         error: function (error) {
//           console.log("Gift not added");
//         },
//       });
//       $('.gift_checkmark').removeAttr('disabled');
//     }
//     else{
//       $('.gift_checkmark').attr('disabled','');
//       $.ajax({
//         type: "POST",
//         url: "/cart/change.js",
//         dataType: "json",
//         signal: abortController.signal,
//         data: {
//           quantity: 0,
//           id: 40105492774947,
//           sections: "cart-drawer",
//         },
//         success: function (response) {
//           // console.log("Gift", response);
//           const html = new DOMParser().parseFromString(
//             response.sections["cart-drawer"],
//             "text/html"
//           );
//           document.querySelector("cart-quantity").updateHTML(html);
//           document.dispatchEvent(new CustomEvent('theme:cartchanged'));
//         },
//         error: function (error) {
//           console.log("Gift not added");
//         },
//       });
//       $('.gift_checkmark').removeAttr('disabled');
//     }
//   }

//     $('.siil_op li').click(function () {
//     const giftAddId = $('[name="gift_oolor"]:checked').data().productVariantId;
//     const colorVal = $('[name="gift_oolor"]:checked').val();
//     $('.sow__selected_val').text(colorVal);
//     $('.sel__img img').addClass('hidden');
//     $(`[data-color="${colorVal}"]`).removeClass('hidden');
//     $('.add_on_thres_limit').attr('data-add-id', giftAddId);
//     console.log($('[name="gift_oolor"]:checked').data().productVariantId)
//   });
//   $('.add_on_thres_limit').click(function () {
//     const prodId = $('.add_on_thres_limit').data().addId;
//     $.ajax({
//         type: "POST",
//         url: "/cart/add.js",
//         dataType: "json",
//         data: {
//           quantity: 1,
//           id: prodId,
//           sections: "cart-drawer",
//         },
//         success: function (response) {
//           const html = new DOMParser().parseFromString(
//             response.sections["cart-drawer"],
//             "text/html"
//           );
//           cartDrawerUpdate();
//           document.querySelector("cart-quantity").updateHTML(html);
//           document.dispatchEvent(new CustomEvent('theme:cartchanged'));
//         },
//         error: function (error) {
//           console.log("gift not added");
//         },
//       });
//   });
// });


// function cartDrawerUpdate() {
//   var url = window.location.href;
//   fetch(url)
//    .then(response => response.text())
//    .then(html => {
//     var parser = new DOMParser();
//     var doc = parser.parseFromString(html, 'text/html');
//     if (doc.querySelector('.cart_drawer__inner') != null) {
//      var mainSectionContent = doc.querySelector('.cart_drawer__inner').innerHTML;
//      document.querySelector('.cart_drawer__inner').innerHTML = mainSectionContent;
//     }
//    })
//    .catch(error => {
//     console.error('Error fetching collection main section:', error);
//    });
//  }

//  // Add this to your existing $(document).ready() function or at the end of your JS file

// $(document).on("click", ".remove_discount_btn", async function(e) {
//   e.preventDefault();
//   const discountCode = $(this).data("discount-code");
  
//   try {
//     // Get current cart data
//     const cartResponse = await fetch('/cart.json');
//     const cartData = await cartResponse.json();
    
//     // Get all current discount codes
//     let currentCodes = [];
//     if (cartData.discount_codes && cartData.discount_codes.length) {
//       currentCodes = cartData.discount_codes
//         .filter(code => code.code !== discountCode && code.applicable)
//         .map(code => code.code);
//     }
    
//     // Update cart with remaining discount codes
//     const updateResponse = await fetch("/cart/update.js", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({
//         discount: currentCodes.join(','),
//         sections: "cart-drawer",
//       }),
//     });
    
//     const data = await updateResponse.json();
    
//     // Update the cart drawer
//     const html = new DOMParser().parseFromString(
//       data.sections["cart-drawer"],
//       "text/html"
//     );
//     document.querySelector("cart-quantity").updateHTML(html);
//     document.dispatchEvent(new CustomEvent('theme:cartchanged'));
    
//     console.log(`Discount code "${discountCode}" removed successfully`);
//   } catch (error) {
//     console.error("Error removing discount code:", error);
//   }
// });

// Add this to your existing $(document).ready() function or at the end of your JS file

// $(document).on("click", ".remove_discount_btn", async function(e) {
//   e.preventDefault();
//   const discountCodeToRemove = $(this).data("discount-code");
  
//   // Disable button during processing
//   $(this).prop('disabled', true);
  
//   try {
//     // Get current cart data
//     const cartResponse = await fetch('/cart.json');
//     const cartData = await cartResponse.json();
    
//     // Get all current discount codes and filter out the one to remove
//     let remainingCodes = [];
//     if (cartData.discount_codes && cartData.discount_codes.length) {
//       remainingCodes = cartData.discount_codes
//         .filter(code => {
//           // Keep only applicable codes that are NOT the one being removed
//           return code.applicable && code.code !== discountCodeToRemove;
//         })
//         .map(code => code.code);
//     }
    
//     // Update cart with remaining discount codes (empty string if no codes left)
//     const updateResponse = await fetch("/cart/update.js", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({
//         discount: remainingCodes.length > 0 ? remainingCodes.join(',') : '',
//         sections: "cart-drawer",
//       }),
//     });
    
//     const data = await updateResponse.json();
    
//     // Update the cart drawer
//     const html = new DOMParser().parseFromString(
//       data.sections["cart-drawer"],
//       "text/html"
//     );
//     document.querySelector("cart-quantity").updateHTML(html);
//     document.dispatchEvent(new CustomEvent('theme:cartchanged'));
    
//     console.log(`Discount code "${discountCodeToRemove}" removed successfully`);
//   } catch (error) {
//     console.error("Error removing discount code:", error);
//     // Re-enable button if there's an error
//     $(this).prop('disabled', false);
//   }
// });